import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const TopFlex = styled(Flex)``
export const FileFlex = styled(Flex)`
  gap: 12px;
`
export const DownLoadFlex = styled(Flex)`
  gap: 26px;
  cursor: pointer;
`
export const FileDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const CommonDiv = styled.div``

export const HeaderPartDiv = styled.div`
  margin: 48px 24px 0;
`
export const LogoDiv = styled.div`
  padding: 15px 10px;
  background: ${COLORS.GREY_T_95};
`
export const DateDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const LogoNameSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const ContentDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
`
export const TitleSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
  white-space: nowrap;
`
export const LogoFlex = styled(Flex)``
export const ContentInfo = styled.div`
  margin-top: 20px;
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`
export const RadioDiv = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-right: 10px;
`

export const CheckBoxDiv = styled.div`
  padding: 5px 0 5px 6px;
`
export const CheckBoxFlex = styled(Flex)`
  margin-bottom: 18px;
`
